import { Injectable } from '@angular/core';

import { GqlServiceV2 } from '../modules/content/service/gql.service-v2';
import { GridInput } from '@it2go/data-grid';
import { filterFrag } from './types/filter.types';
import { LoanAgreementTransactionGridObject } from '@libs/types/src/mado/object-type/loan-agreement-transaction.object';

@Injectable({ providedIn: 'root' })
export class LoanAgreementTransactionGqlService extends GqlServiceV2 {

    public getLoanAgreementTransactions(input: GridInput | null, frag: string) {
        return this.query<LoanAgreementTransactionGridObject>(
            `
                query($input: GridInput!) {
                    loanAgreementTransaction {
                        filter(input: $input) {
                            ${filterFrag}
                            items {
                                ${frag}
                            }
                        }
                    }
                }
            `,
            { input },
        );
    }
}
